//import './publicPath';
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./fonts";
import App from "./App";
import LandingPage from "./LandingPage";
import userLoader from "./middleware/userLoader.js";
import standaloneLoader from "./middleware/standaloneLoader.js";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ErrorPage2 } from "./error-page";

const root = ReactDOM.createRoot(document.getElementById("root"));
const router = createBrowserRouter([
  {
    path: "/",
    element: <ErrorPage2 />,
    errorElement: <ErrorPage2 />,
  },
   // ✅ standalone media route (must come before "/:username")
    {
      path: "/:username/s/:mediaId",
      element: <LandingPage />,
      loader: standaloneLoader, // keep if you want user preloading
      errorElement: <ErrorPage2 />,
    },
  {
    path: "/:username",
    element: <App />,
    loader: userLoader,
    errorElement: <ErrorPage2 />,
  },
]);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
//   <App />

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
